import { emailConstants } from "../_constants";

export function emailList(state = {}, action) {
  switch (action.type) {
    case emailConstants.GET_EMAIL_SETTINGS_LIST_REQUEST:
      return {
        loading: true,
      };
    case emailConstants.GET_EMAIL_SETTINGS_LIST_SUCCESS:
      return {
        item: action.emailList,
      };
    case emailConstants.GET_EMAIL_SETTINGS_LIST_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeEmailList(state = {}, action) {
  switch (action.type) {
    case emailConstants.GET_ACTIVE_EMAIL_SETTINGS_LIST_REQUEST:
      return {
        loading: true,
      };
    case emailConstants.GET_ACTIVE_EMAIL_SETTINGS_LIST_SUCCESS:
      return {
        item: action.activeEmailList,
      };
    case emailConstants.GET_ACTIVE_EMAIL_SETTINGS_LIST_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function postSettings(state = {}, action) {
  switch (action.type) {
    case emailConstants.POST_EMAIL_SETTINGS_LIST_REQUEST:
      return {
        loading: true,
      };
    case emailConstants.POST_EMAIL_SETTINGS_LIST_SUCCESS:
      return {
        item: action.postSettings,
      };
    case emailConstants.POST_EMAIL_SETTINGS_LIST_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}